import { render, staticRenderFns } from "./ImgConfig.vue?vue&type=template&id=3c230d7f&scoped=true&"
import script from "./ImgConfig.vue?vue&type=script&lang=js&"
export * from "./ImgConfig.vue?vue&type=script&lang=js&"
import style0 from "./ImgConfig.vue?vue&type=style&index=0&id=3c230d7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c230d7f",
  null
  
)

export default component.exports